import request from "@/utils/request";

/**
 *  获取绑定列表
 * @param {*} data
 * @returns
 */
export function fetchBindList(params) {
  return request({
    url: "/api/user/link",
    method: "get",
    params,
  });
}

/**
 *  删除绑定
 * @param {*} data
 * @returns
 */
export function fetchDeleteBind(data) {
  return request({
    url: "/api/user/link",
    method: "delete",
    data,
  });
}
